import L from 'leaflet';

// Helper function for state-based colors
const getStateColors = (state) => {
  switch(state) {
    case 'locked_out':
      return {
        pinColor: '#0d3825',    // Red
        ringColor: '#ef4444',   // Red (user preference)
        iconColor: '#0d3825'    // Dark red
      };
    case 'available':
      return {
        pinColor: '#0d3825',    // AiRagri green
        ringColor: 'white',
        iconColor: '#0d3825'
      };
    default:
      // Default to available/green for any unknown state
      return {
        pinColor: '#0d3825',
        ringColor: 'white',
        iconColor: '#0d3825'
      };
  }
};

export const createMachineryIcon = (speed = 0, state = null) => {
  const speedText = Math.round(speed).toString();
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base with state-specific color -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Status ring with state-specific color -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>

      <!-- Icon background circle (empty/white) -->
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- Tractor icon with state-specific color -->
      <!-- Main body -->
      <rect x="98.75" y="115.75" width="50" height="16" rx="2" fill="${colors.iconColor}"/>
      <!-- Cabin -->
      <rect x="118.75" y="100.75" width="18" height="18" rx="2" fill="${colors.iconColor}"/>
      <!-- Large rear wheel -->
      <circle cx="133.75" cy="140.75" r="15" fill="none" stroke="${colors.iconColor}" stroke-width="1.5"/>
      <circle cx="133.75" cy="140.75" r="10" fill="${colors.iconColor}"/>
      <!-- Small front wheel -->
      <circle cx="108.75" cy="138.75" r="10" fill="none" stroke="${colors.iconColor}" stroke-width="1.5"/>
      <circle cx="108.75" cy="138.75" r="6" fill="${colors.iconColor}"/>
      <!-- Exhaust pipe -->
      <rect x="136.75" y="95.75" width="3" height="12" fill="${colors.iconColor}"/>
      <!-- Front grille -->
      <rect x="95.75" y="118.75" width="3" height="10" fill="${colors.iconColor}"/>

      <!-- Speed bubble with state-specific color -->
      <circle cx="185" cy="72" r="33.75" fill="${colors.pinColor}"/>
      <text x="185" y="82.5" text-anchor="middle" font-family="Arial, sans-serif" font-size="27" fill="white" font-weight="bold">${speedText}</text>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};
